import apiClient from './apiClient';

export interface F937 {
  f937_01: number; f937_11: number; f937_21: number;
  f937_91: string; f937_92: string | null; f937_93: string;
}
export interface ListResponse { data: F937[]; total: number; page: number; size: number; }
export interface ValidationError { field: string; message: string; }

export const nhiParamsApi = {
  async list(page = 1, size = 200): Promise<ListResponse> {
    return (await apiClient.get('/api/nhi-params', { params: { page, size } })).data;
  },
  async get(id: number): Promise<F937> {
    return (await apiClient.get(`/api/nhi-params/${id}`)).data;
  },
  async create(data: { f937_01: number; f937_11: number; f937_21: number }): Promise<F937> {
    return (await apiClient.post('/api/nhi-params', data)).data;
  },
  async update(id: number, data: { f937_11: number; f937_21: number }): Promise<F937> {
    return (await apiClient.put(`/api/nhi-params/${id}`, data)).data;
  },
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/nhi-params/${id}`);
  },
};
